import { FULFILLED } from '../action-helper'
import { ADD_FLASH_MESSAGE } from './actions'
import { FlashMessageState } from './FlashMessageState'

const initialState: FlashMessageState = {
    messages: [],
}

export const flashMessageReducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        case FULFILLED(ADD_FLASH_MESSAGE):
            if (['errors', 'warnings', 'info'].indexOf(action.payload.type) !== -1) {
                return {
                    ...state,
                    messages: [...state.messages, action.payload],
                }
            }
    }

    return state
}
